import type { RefCallback } from 'react'
import { useInView } from 'react-intersection-observer'

import { Experiments } from 'constants/optimizely'
import useExperiment from 'hooks/Optimizely/useExperiment'

function getStructuredFacilities(offerDetails: App.Offer): Array<App.StructuredFacilityGroup> | undefined {
  return 'structuredFacilities' in offerDetails ? offerDetails.structuredFacilities : undefined
}

interface StructuredFacilitiesReworkState {
  structuredFacilitiesReworkActivationRef: RefCallback<HTMLDivElement>
  structuredFacilitiesRework?: Array<App.StructuredFacilityGroup>
}

function useStructuredFacilitiesRework(offerDetails: App.Offer): StructuredFacilitiesReworkState {
  const structuredFacilities = getStructuredFacilities(offerDetails)
  const hasStructuredFacilities = !!structuredFacilities?.length
  const [structuredFacilitiesReworkActivationRef, structuredFacilitiesReworkInView] = useInView({
    triggerOnce: true,
    threshold: 0.25,
  })
  const { isAnyVariant } = useExperiment(Experiments.croFacilitiesRework, {
    canActivate: structuredFacilitiesReworkInView && hasStructuredFacilities,
  })

  return {
    structuredFacilitiesReworkActivationRef,
    structuredFacilitiesRework: isAnyVariant && hasStructuredFacilities ? structuredFacilities : undefined,
  }
}

export default useStructuredFacilitiesRework
